import React, { createContext, useContext, useMemo } from "react";
import fr from "./locales/fr";
import en from "./locales/en";
import ar from "./locales/ar";
import es from "./locales/es";
import it from "./locales/it";
import de from "./locales/de";
import zh from "./locales/zh";

export const LOCALES = { fr, en, ar, es, it, de, zh };
export const LANGS = [
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "en", label: "English", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "es", label: "Español", dir: "ltr" },
  { code: "it", label: "Italiano", dir: "ltr" },
  { code: "de", label: "Deutsch", dir: "ltr" },
  { code: "zh", label: "中文", dir: "ltr" },
];
export const DEFAULT_LANG = "fr";
export const isRTL = (lang) => lang === "ar";

const LangContext = createContext({ lang: "fr", t: (k) => k });

export function LangProvider({ lang, children }) {
  const value = useMemo(() => {
    const dict = LOCALES[lang] || fr;
    const t = (key, params) => {
      let s = dict[key] ?? fr[key] ?? key;
      if (params)
        Object.entries(params).forEach(([k, v]) => {
          s = s.replaceAll(`{${k}}`, v);
        });
      return s;
    };
    return { lang, t, dir: isRTL(lang) ? "rtl" : "ltr" };
  }, [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);

export const localName = (obj, lang, field = "name") => {
  if (!obj) return "";
  return (lang === "fr" && obj[`${field}_fr`]) || obj[field] || "";
};
export const localDesc = (obj, lang) =>
  (lang === "fr" && obj?.description_fr) || obj?.description || "";
